<template>
    <ColorPicker
        class="sbs-color-picker"
        v-bind="colorPickerData"
        @color-change="updateColor" />
</template>

<script>
import { ColorPicker } from 'vue-accessible-color-picker';
import { getRandomId } from '../../utils/helpers.js';

const DEFAULT_COLOR_HEX = '#ffffff';

export default {
    name: 'SbsColorPicker',
    emits: ['update:modelValue'],
    components: {
        ColorPicker,
    },
    computed: {
        colorPickerId() {
            return this.id || `sbs-color-picker-${getRandomId()}`;
        },
        colorPickerData() {
            return {
                color: this.modelValue || DEFAULT_COLOR_HEX,
                id: this.colorPickerId,
            };
        },
    },
    methods: {
        updateColor(value) {
            this.$emit('update:modelValue', value.colors.hex, value);
        },
    },
    props: {
        modelValue: {
            type: String,
            default: null,
        },
    },
};
</script>

<style lang="scss">
.sbs-color-picker {
    display: flex;
    flex-direction: column;
    padding: 0;

    &.vacp-color-picker {
        display: flex;
        flex-direction: column;
        grid-gap: 0;
        width: 100%;
        padding: 0;
    }

    .vacp-color-space {
        height: 185px;
        margin-bottom: 15px;
        border: 1px solid $gray;
        border-radius: $rounded-15;
        cursor: grab;

        &:active {
            cursor: grabbing;
        }
    }

    .vacp-color-space-thumb {
        width: 23px;
        height: 23px;
        border: 2px solid $white;
        box-shadow: none;

        &:focus {
            outline: none;
            box-shadow: none;

            &:not(:active) {
                box-shadow: 0 0 0 2px $primary;
            }
        }
    }

    .vacp-range-input {
        width: 100%;
        height: 25px;
        margin-top: 0;
        margin-bottom: 0;

        &:focus {
            &::-webkit-slider-runnable-track {
                border: none;
                outline: none;
            }

            &::-webkit-slider-thumb {
                box-shadow: 0 0 0 2px $primary;
            }
        }

        &::-webkit-slider-runnable-track {
            height: 100%;
            border-radius: $rounded-pill;
            outline-offset: 1px;
            cursor: pointer;
        }

        &::-webkit-slider-thumb {
            width: 23px;
            height: 23px;
            margin-top: 1px;
            border: 2px solid $white;
            box-shadow: none;
            cursor: grab;

            &:active {
                cursor: grabbing;
            }
        }
    }

    .vacp-range-input-label-text,
    .vacp-range-input-label--alpha,
    .vacp-copy-button,
    .vacp-color-inputs {
        display: none;
    }
}
</style>
